module.exports = __webpack_public_path__ + "img/estacionamiento-privado.4807d783.svg";